<script lang="ts">
  import { loadInternalLink } from '#app/lib/utils'
  import { i18n } from '#user/lib/i18n'
  import { mainUser } from '#user/lib/main_user'
</script>

<div class="login-buttons">
  {#if mainUser}
    <a class="button dark-grey" onclick={loadInternalLink} href="/">{i18n('back to your inventory')}</a>
  {:else}
    <a class="button secondary bold" onclick={loadInternalLink} href="/signup">{i18n('sign up')}</a>
    <a class="button success bold" onclick={loadInternalLink} href="/login">{i18n('login')}</a>
  {/if}
</div>

<style lang="scss">
  @import "general/scss/utils";

  .login-buttons{
    @include display-flex(row, center, center, wrap);
    // Those margins are compensating for Safari bad flex support
    margin-block: 1em;
    .button{
      min-width: 10em;
      // Reset radius
      @include radius(0);
    }
    @include radius-horizontal-group;

    /* Small screens */
    @media screen and (width < $small-screen){
      margin: 0.5em;
      margin-block-end: 1em;
    }
    /* Large screens */
    @media screen and (width >= $small-screen){
      margin: auto;
    }
  }
</style>
